import classNames from 'classnames'
import moment from 'moment-timezone'

import { OrderStatus } from '@apps-common/config/orders'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { IOrderListModel } from '@apps-common/types/portal/order'
import { ROUTE_ORDER_DETAILS } from '@apps-radionet-portal/config/private-routes'

interface IProps {
  bgClasses: string
  textClasses: string
  order: IOrderListModel
}

export const OrderListCardSm: React.FC<IProps> = (props) => {
  const { navigateForward } = useNavigation()
  const { bgClasses, textClasses, order } = props
  // const { success, warning, pending } = useThemeTrafficLightColors()

  const { orderId, orderNo, orderDate, status } = order

  const getStatusClass = () => {
    if (status === OrderStatus.complete) {
      return { text: 'text-on-success', bg: 'bg-success' }
    }

    if (status === OrderStatus.cancelled) {
      return { text: 'text-on-warning', bg: 'bg-warning' }
    }

    return { text: 'text-on-info', bg: 'bg-info' }
  }

  const getStatusText = () => {
    if (status === OrderStatus.complete) {
      return 'Complete'
    }

    if (status === OrderStatus.cancelled) {
      return 'Cancelled'
    }

    return 'Pending'
  }

  const statusClasses = getStatusClass()
  const statusText = getStatusText()

  return (
    <button
      type='button'
      className={classNames('flex items-center justify-start gap-[10px]')}
      onClick={() => navigateForward({ routeUrl: ROUTE_ORDER_DETAILS.buildPath(orderId), route: ROUTE_ORDER_DETAILS })}
    >
      <div className={classNames('w-[3px] h-[80%] rounded-[3px]', statusClasses.bg)} />
      <div className={classNames('grow p-4 rounded-2xl overflow-hidden hover:cursor-pointer hover:opacity-80', bgClasses)}>
        <div className='flex items-center justify-between'>
          <div>
            <div className='flex items-center justify-start gap-[10px]'>
              <div className={classNames('w-[15px] h-[15px] rounded-[7.5px]', statusClasses.bg)} />
              <h4 className={classNames('jost-light text-[0.8em]', textClasses)}>{moment(orderDate).format('DD-MM-YYYY')}</h4>
            </div>
            <div className='pl-[25px]'>
              <div className='grow items-start flex justify-between'>
                <h4 className={classNames('jost-light text-[0.9em]', textClasses)}>{orderNo}</h4>
              </div>
            </div>
          </div>
          <div
            className={classNames(
              'rounded-3xl px-[1rem] py-[0.15rem] text-[0.8em] jost min-w-[90px]',
              statusClasses.bg,
              statusClasses.text
            )}
          >
            {statusText}
          </div>
        </div>
      </div>
    </button>
  )
}
